import { metrics } from '@atlassian/browser-metrics';
import { commitDetailsEntryPoint } from '@atlassian/jira-development-board-commit-details-popup/entrypoint';
import { DevInfoTypes } from '@atlassian/jira-development-board-common/src/types.tsx';
import { pullRequestDetailsEntryPoint } from '@atlassian/jira-development-board-pr-details-popup/entrypoint';

const commitDetailsPopupLoad = metrics.interaction({
	key: 'list.commit-details-popup-load',
});

const prDetailsPopupLoad = metrics.interaction({
	key: 'list.pr-details-popup-load',
});

export const metricsDev = {
	[DevInfoTypes.COMMIT]: commitDetailsPopupLoad,
	[DevInfoTypes.PULLREQUEST]: prDetailsPopupLoad,
};

export const experienceDetails = {
	[DevInfoTypes.COMMIT]: {
		id: 'commitDetailsPopup',
		name: 'jiraSoftwareListCommitDetailsPopup',
	},
	[DevInfoTypes.PULLREQUEST]: { id: 'prDetailsPopup', name: 'jiraSoftwareListPrDetailsPopup' },
};

export const packageDetails = {
	[DevInfoTypes.COMMIT]: {
		id: 'renderCommitDetailsPopup',
		packageName: 'jiraDevelopmentListCommitDetailsPopup',
		teamName: 'fusion-isotopes',
	},
	[DevInfoTypes.PULLREQUEST]: {
		id: 'renderPRDetailsPopup',
		packageName: 'jiraDevelopmentListPrDetailsPopup',
		teamName: 'fusion-isotopes',
	},
};

export const popupEntryPoints = {
	[DevInfoTypes.COMMIT]: commitDetailsEntryPoint,
	[DevInfoTypes.PULLREQUEST]: pullRequestDetailsEntryPoint,
};
